import { useState, useEffect } from "react";

// Custom hooks
export function useSecureData(token) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSecureData = async () => {
      const secureResponse = await fetch(
        "https://kjpp-server.vercel.app/middleware/secure-data",
        {
          method: "GET",
          headers: {
            Authorization: token ? token : "",
            "Content-Type": "application/json",
          },
        }
      );

      if (!secureResponse.ok) {
        setError(true);
        return;
      }

      const data = await secureResponse.json();
      const isExpire = new Date(data.exp * 1000) < new Date();

      if (isExpire) {
        setError(true);
      }

      setData(data);
      setLoading(false);
    };

    fetchSecureData();
  }, [token]);

  return { data, loading, error };
}
